// NOTE:
// This template/ctrl intentionally uses the legacy Angular editor
// rather than the React-based Slate editor. The reason is that the sanitization
// logic written for Angular flattens API HTML into inline-only markup, which
// breaks Slate’s requirement for block-level structure. To avoid refactoring the
// CS/React bridge and Angular filters, we continue to use the Angular editor here.
import random from 'helpers/random';

import {
  SMS_OPT_OUT_INSTRUCTIONS_POLICY_OPTIONS
} from 'react/types/sms_settings';

import {
  SMS_OPT_OUT_POLICY_HINT_TEXT
} from 'react/types/constants';

import featureNames from 'constants/feature_names';

angular.module('gym.components').directive('sequencePayloadEditor', ["$filter", "$modal", "ReactModal", "flash", "DefaultReplyAddressService", "SmsValidationService", "PushNotificationValidationService", "PushNotificationOptionsService", "AssetLibraryService", "SMSesSentThisMonthService", "FeatureAvailabilityService", "MERGE_TAG_LIST", "PAYMENT_MERGE_TAGS", "CREDIT_VOUCHER_MERGE_TAGS", "MEMBERSHIP_MERGE_TAGS", "BOOKING_MERGE_TAGS", "GRADING_MERGE_TAGS", "STYLE_MERGE_TAGS", "SUSPENSION_MERGE_TAGS", "RECURRING_BOOKING_MERGE_TAGS", "LATE_CANCELLED_BOOKING_MERGE_TAGS", "BOOKING_CANCELLATION_MERGE_TAGS", "WAITLIST_ATTENDEE_MERGE_TAGS", "PERFORMED_WORKOUT_MERGE_TAGS", "MOBILE_APP_EMAIL_INVITE_MERGE_TAG_LIST", "MOBILE_APP_SMS_INVITE_MERGE_TAG_LIST", function($filter, $modal, ReactModal, flash, DefaultReplyAddressService, SmsValidationService, PushNotificationValidationService, PushNotificationOptionsService, AssetLibraryService, SMSesSentThisMonthService, FeatureAvailabilityService, MERGE_TAG_LIST, PAYMENT_MERGE_TAGS, CREDIT_VOUCHER_MERGE_TAGS, MEMBERSHIP_MERGE_TAGS, BOOKING_MERGE_TAGS, GRADING_MERGE_TAGS, STYLE_MERGE_TAGS, SUSPENSION_MERGE_TAGS, RECURRING_BOOKING_MERGE_TAGS, LATE_CANCELLED_BOOKING_MERGE_TAGS, BOOKING_CANCELLATION_MERGE_TAGS, WAITLIST_ATTENDEE_MERGE_TAGS, PERFORMED_WORKOUT_MERGE_TAGS, MOBILE_APP_EMAIL_INVITE_MERGE_TAG_LIST, MOBILE_APP_SMS_INVITE_MERGE_TAG_LIST) {
  return {
    restrict: 'EA',
    template: require('templates/components/sequences/sequencePayloadEditor.html.slim'),
    scope: {
      gym: '=',
      payload: '=',
      sequence: '=',
      error: '=',
      isBookingSequence: '&',
      isPaymentSequence: '&',
      isPaymentRelatedSequence: '&',
      isMembershipSequence: '&',
      isStyleSequence: '&',
      isGradingSequence: '&',
      isSuspensionSequence: '&',
      isRecurringBookingSequence: '&',
      isLateBookingCancellationSequence: '&',
      isBookingCancellationSequence: '&',
      isWaitlistAttendeeSequence: '&',
      isPerformedWorkoutSequence: '&',
      isSendMobileAppInviteEmailStep: '=',
      isSendMobileAppInviteSmsStep: '=',
      humanizedRecipientChoice: '&',
      recipientChoiceHint: '&',
      pushNotificationRoutes: '='
    },
    link: {
      pre: function($scope) {
        var base, ref, ref1;
        $scope.id = random();
        $scope.merge_tags = [MERGE_TAG_LIST];
        (base = $scope.payload).reply_address || (base.reply_address = DefaultReplyAddressService.getDefaultEmail());
        $scope.smsOptOutInstructionsOptions = SMS_OPT_OUT_INSTRUCTIONS_POLICY_OPTIONS;
        $scope.smsHintText = SMS_OPT_OUT_POLICY_HINT_TEXT;
        $scope.featureNames = featureNames;
        $scope.pushNotificationRoutesContext = function() {
          if ($scope.isPaymentSequence()) {
            return 'payment_sequence';
          } else if ($scope.isBookingSequence()) {
            return 'booking_sequence';
          } else if ($scope.isMembershipSequence()) {
            return 'membership_sequence';
          } else if ($scope.isPerformedWorkoutSequence()) {
            return 'workout_sequence';
          } else {
            return '';
          }
        };
        $scope.pushNotificationRoutes || ($scope.pushNotificationRoutes = [
          {
            label: "No preference (open app to Notifications list)",
            value: ''
          }
        ]);
        $scope.toggleAssetLibrary = function() {
          return AssetLibraryService.open({
            mode: 'select'
          }).then(function(asset) {
            $scope.payload.push_notification_image_asset_id = asset.id;
            $scope.payload.push_notification_image_url = asset.attached_url;
            return $scope.payload.push_notification_image_thumb_url = asset.thumb_url;
          });
        };
        $scope.removeImage = function() {
          $scope.payload.push_notification_image_asset_id = null;
          $scope.payload.push_notification_image_url = null;
          return $scope.payload.push_notification_image_thumb_url = null;
        };
        $scope.previewImage = function() {
          return ReactModal.open({
            component: 'PushNotificationImageModal',
            props: {
              imageUrl: $scope.payload.push_notification_image_url,
              replaceImage: $scope.toggleAssetLibrary,
              removeImage: $scope.removeImage
            }
          });
        };
        if ($scope.payload.type === 'PushNotificationSequencePayload' && $scope.pushNotificationRoutes.length) {
          if ((ref = $scope.payload) != null) {
            ref.push_notification_route_name = ((ref1 = $scope.payload) != null ? ref1.push_notification_route_name : void 0) || $scope.pushNotificationRoutes[0].value;
          }
        }
        $scope.setReplyAddress = function(email) {
          return $scope.$evalAsync(function() {
            return $scope.payload.reply_address = email;
          });
        };
        if ($scope.gym.mobile_app_enabled && !$scope.isSendMobileAppInviteEmailStep && !$scope.isSendMobileAppInviteSmsStep) {
          $scope.merge_tags = [$scope.merge_tags[0].concat(['mobile-app-ios-app-store-link', 'mobile-app-google-app-store-link'])];
        }
        if ($scope.isSendMobileAppInviteEmailStep) {
          $scope.merge_tags = [$scope.merge_tags[0].concat(MOBILE_APP_EMAIL_INVITE_MERGE_TAG_LIST)];
        }
        if ($scope.isSendMobileAppInviteSmsStep) {
          $scope.merge_tags = [$scope.merge_tags[0].concat(MOBILE_APP_SMS_INVITE_MERGE_TAG_LIST)];
        }
        $scope.payment_merge_tags = FeatureAvailabilityService.isAvailable('credit_vouchers') ? [PAYMENT_MERGE_TAGS.concat(CREDIT_VOUCHER_MERGE_TAGS)] : [PAYMENT_MERGE_TAGS];
        $scope.membership_merge_tags = [MEMBERSHIP_MERGE_TAGS];
        $scope.booking_merge_tags = [BOOKING_MERGE_TAGS];
        $scope.grading_merge_tags = [GRADING_MERGE_TAGS];
        $scope.style_merge_tags = [STYLE_MERGE_TAGS];
        $scope.suspension_merge_tags = [SUSPENSION_MERGE_TAGS];
        $scope.recurring_booking_merge_tags = [RECURRING_BOOKING_MERGE_TAGS];
        $scope.late_cancelled_booking_merge_tags = [LATE_CANCELLED_BOOKING_MERGE_TAGS];
        $scope.booking_cancellation_merge_tags = [BOOKING_CANCELLATION_MERGE_TAGS];
        $scope.waitlist_attendee_merge_tags = [WAITLIST_ATTENDEE_MERGE_TAGS];
        return $scope.performed_workout_merge_tags = [PERFORMED_WORKOUT_MERGE_TAGS];
      }
    },
    controller: ["$scope", "$rootScope", "FeatureAvailabilityService", function($scope, $rootScope, FeatureAvailabilityService) {
      var getMergeTagGroups, paymentMergeTags;
      if ($scope.payload.type === 'SmsSequencePayload' || $scope.isSendMobileAppInviteSmsStep) {
        SMSesSentThisMonthService.load();
      }
      $scope.getSmsesSentThisMonth = SMSesSentThisMonthService.getCount;
      $scope.users = $rootScope.gym.users.asJson();
      $scope.useNewEditor = $rootScope.gym.gym_config.use_slate_editor && !$scope.isSendMobileAppInviteEmailStep;
      paymentMergeTags = FeatureAvailabilityService.isAvailable('credit_vouchers') ? PAYMENT_MERGE_TAGS.concat(CREDIT_VOUCHER_MERGE_TAGS) : PAYMENT_MERGE_TAGS;
      angular.element('.not-sortable')[0].addEventListener('touchstart', function(e) {
        return e.stopPropagation();
      });
      $scope.getErrors = function() {
        var template;
        if ($scope.error) {
          return $scope.error;
        }
        template = {
          channel: $scope.payload.type === 'SmsSequencePayload' && 'sms',
          content: $scope.payload.body,
          sms_opt_out_instructions_policy: $scope.payload.sms_opt_out_instructions_policy,
          push_notification_route_name: $scope.payload.push_notification_route_name
        };
        return SmsValidationService.getErrors(template);
      };
      $scope.getTitleErrorsArray = function() {
        if (!$scope.payload.subject && $scope.sequence.errors['sequence_steps.sequence_payloads.subject']) {
          return ['The message subject is required'];
        }
      };
      getMergeTagGroups = function() {
        var contactMergeTags, groups;
        contactMergeTags = MERGE_TAG_LIST;
        if ($rootScope.gym.mobile_app_enabled && !$scope.isSendMobileAppInviteEmailStep && !$scope.isSendMobileAppInviteSmsStep) {
          contactMergeTags = contactMergeTags.concat(['mobile-app-ios-app-store-link', 'mobile-app-google-app-store-link']);
        }
        if ($scope.isSendMobileAppInviteEmailStep) {
          contactMergeTags = contactMergeTags.concat(MOBILE_APP_EMAIL_INVITE_MERGE_TAG_LIST);
        }
        if ($scope.isSendMobileAppInviteSmsStep) {
          contactMergeTags = contactMergeTags.concat(MOBILE_APP_SMS_INVITE_MERGE_TAG_LIST);
        }
        groups = [
          {
            title: 'Contact merge tags',
            tags: contactMergeTags
          }
        ];
        if ($scope.isPaymentSequence()) {
          groups.push({
            title: 'Payment merge tags',
            tags: paymentMergeTags
          });
        }
        if ($scope.isBookingSequence()) {
          groups.push({
            title: 'Booking merge tags',
            tags: BOOKING_MERGE_TAGS
          });
        }
        if ($scope.isMembershipSequence()) {
          groups.push({
            title: 'Membership merge tags',
            tags: MEMBERSHIP_MERGE_TAGS
          });
        }
        if ($scope.isGradingSequence()) {
          groups.push({
            title: 'Grading merge tags',
            tags: GRADING_MERGE_TAGS
          });
        }
        if ($scope.isStyleSequence()) {
          groups.push({
            title: 'Style merge tags',
            tags: STYLE_MERGE_TAGS
          });
        }
        if ($scope.isSuspensionSequence()) {
          groups.push({
            title: 'Suspension merge tags',
            tags: SUSPENSION_MERGE_TAGS
          });
        }
        if ($scope.isRecurringBookingSequence()) {
          groups.push({
            title: 'Recurring booking merge tags',
            tags: RECURRING_BOOKING_MERGE_TAGS
          });
        }
        if ($scope.isLateBookingCancellationSequence()) {
          groups.push({
            title: 'Late Booking Cancellation merge tags',
            tags: LATE_CANCELLED_BOOKING_MERGE_TAGS
          });
        }
        if ($scope.isBookingCancellationSequence()) {
          groups.push({
            title: 'Booking Cancellation merge tags',
            tags: BOOKING_CANCELLATION_MERGE_TAGS
          });
        }
        if ($scope.isWaitlistAttendeeSequence()) {
          groups.push({
            title: 'Waitlist attendee merge tags',
            tags: WAITLIST_ATTENDEE_MERGE_TAGS
          });
        }
        if ($scope.isPerformedWorkoutSequence()) {
          groups.push({
            title: 'Performed workout merge tags',
            tags: PERFORMED_WORKOUT_MERGE_TAGS
          });
        }
        return groups;
      };
      $scope.$watch('sequence.trigger', function() {
        return $scope.mergeTagGroups = getMergeTagGroups();
      });
      $scope.isEmailUserPayload = function() {
        return $scope.payload.type === 'EmailUserSequencePayload';
      };
      $scope.isEmailPayload = function() {
        return $scope.payload.type === 'EmailSequencePayload' || $scope.isEmailUserPayload() || $scope.isSendMobileAppInviteEmailStep;
      };
      $scope.isSmsPayload = function() {
        return $scope.payload.type === 'SmsSequencePayload' || $scope.isSendMobileAppInviteSmsStep;
      };
      $scope.isPushNotificationPayload = function() {
        return $scope.payload.type === 'PushNotificationSequencePayload';
      };
      $scope.isSendMobileAppInviteStep = function() {
        return $scope.payload.type === 'MobileAppSequencePayload' && $scope.payload.send_mobile_app_invite;
      };
      $scope.onEmailUserChange = function() {
        var user;
        user = $scope.users.find(function(u) {
          return u.id === $scope.payload.user_id;
        });
        $scope.payload.user_name = user != null ? user.name : void 0;
        return $scope.payload.user_email = user != null ? user.email : void 0;
      };
      $scope.saveLabel = function() {
        switch (false) {
          case !$scope.isEmailPayload():
            return 'Email';
          case !$scope.isSmsPayload():
            return 'SMS';
          case !$scope.isPushNotificationPayload():
            return 'Push Notification';
        }
      };
      $scope.sendToOptions = ['send_to_contact_only', 'send_to_matching_recipients', 'send_to_matching_recipients_with_contact_fallback'];
      $scope.save = function() {
        return $scope.payload.editable = false;
      };
      $scope.getRemainingCharacters = function() {
        if ($scope.isSmsPayload()) {
          return SmsValidationService.getRemainingCharacters($scope.payload.body);
        }
        if ($scope.isPushNotificationPayload()) {
          return PushNotificationValidationService.getRemainingCharacters($scope.payload.body);
        }
      };
      $scope.displayRemainingCharacters = function() {
        if ($scope.isSmsPayload()) {
          return SmsValidationService.displayRemainingCharacters($scope.payload.body);
        }
        if ($scope.isPushNotificationPayload()) {
          return PushNotificationValidationService.displayRemainingCharacters($scope.payload.body);
        }
      };
      $scope.displayRemainingCharactersDetails = function() {
        return $modal.open({
          template: require('templates/gyms/bulk_messages/remaining_characters_details.html.slim'),
          controller: 'RemainingCharactersDetailsModal'
        });
      };
      return $scope.isValid = function() {
        if ($scope.isSmsPayload() || $scope.isPushNotificationPayload()) {
          return $scope.getRemainingCharacters() >= 0;
        } else {
          return true;
        }
      };
    }]
  };
}]);
